import _ from "lodash";

export default {
    bus: new Vue({}),
    toggleOtherIsTyping: null,
    states: Vue.observable({
        blocks: [],
        search: '',
        user: null,
        loading_chats: true,
        loading_messages: false,
        chats: [],
        messages: [],
        activeChat: null,
        emoji: false,
        form: {
            text: '',
            file: null,
        },
        showChatDetails: false,
        otherIsTyping: false,
        autoTranslate: Cookies.get('auto-translate') === 'active',
        translating: [],
        translations: [],
    }),
    accept() {
        axios({
            method: 'post',
            url: `/api/v1/chat/${this.states.activeChat.id}/accept`,
            params: {token: window.jwt_token},
        }).then(resp => {
            this.states.activeChat.draft = false
        })
    },
    translate(messages) {
        let message_ids = _.castArray(messages).map(message => message.id)
        Vue.set(this.states, 'translating', [...this.states.translating, ...message_ids])
        axios({
            method: 'post',
            url: '/api/v1/chat/translate',
            data: {message_ids},
            params: {token: window.jwt_token},
            headers: {locale: window.locale}
        }).then(resp => {
            console.log(resp.data)
            _.forEach(resp.data, (translation, id) => {
                console.log(id, translation)
                this.states.translations.push({id, translation})
            })
        }).finally(() => {
            Vue.set(this.states, 'translating', _.filter(this.states.translation, id => !message_ids.includes(id)))
        })
    },
    messageIsTranslating(message) {
        return this.states.translating.includes(message.id)
    },
    messageIsTranslated(message) {
        return this.findTranslation(message) !== undefined
    },
    findTranslation(message) {
        return _.find(this.states.translations, item => item.id + '' === message.id + '')
    },
    translationAvailable(message) {
        return this.messageIsTranslating(message) || this.messageIsTranslated(message)
    },
    toggleTranslation(message) {
        if (this.messageIsTranslated(message)) {
            this.states.translations = this.states.translations.filter(item => item.id + '' !== message.id + '')
        } else {
            this.translate(message)
        }
    },
    toggleAutoTranslate() {
        Cookies.set('auto-translate', this.states.autoTranslate ? 'active' : 'inactive')
        this.states.autoTranslate = !this.states.autoTranslate
        this.states.autoTranslate && this.translateAll()
        !this.states.autoTranslate && this.originalAll()

    },
    toggleEmoji() {
        this.states.emoji = !this.states.emoji
    },
    addEmoji(emoji) {
        this.states.form.text += emoji.native
        this.states.emoji = false
    },
    async init(user) {
        await this.leaveUserChannel()
        await this.getBlockedUsers()
        this.states.user = user
        await this.getChats();
        await this.joinUserChannel()
        // this.registerTypingIntervals()
        window.addEventListener('beforeunload', () => this.beforeUnload())
        this.joinInitialChat()
    },
    joinInitialChat() {
        let urlParams = new URLSearchParams(window.location.search);
        let chatId = urlParams.get('chat_id');
        let chat = _.find(this.states.chats, chat => chat.id + '' === chatId + '')
        chat !== undefined && this.selectChat(chat)
    },
    getBlockedUsers() {
        axios.get('/api/v1/block-user', {
            params: {token: window.jwt_token},
            headers: {locale: window.locale}
        }).then(resp => this.states.blocks = resp.data)
    },
    isBlocked(user) {
        return this.states.blocks.includes(user.id)
    },
    block(user) {
        axios({
            method: 'post',
            url: '/api/v1/block-user',
            data: {user_id: user.id},
            params: {token: window.jwt_token},
            headers: {locale: window.locale}
        }).then(resp => {
            this.getBlockedUsers()
            this.states.activeChat = null
            Vue.$toast.success(resp.data.msg)
        })
    },
    unblock(user) {
        axios({
            method: 'post',
            url: '/api/v1/unblock-user',
            data: {user_id: user.id},
            params: {token: window.jwt_token},
            headers: {locale: window.locale}
        }).then(resp => {
            Bus.$emit('UserUnblocked', user.id)
            this.getBlockedUsers()
            Vue.$toast.success(resp.data.msg)
        })
    },
    activeChatIsBlocked() {
        return this.isBlocked(this.other_user(this.states.activeChat))
    },
    toggleBlock() {
        let other = this.other_user(this.states.activeChat)
        this.activeChatIsBlocked() ? this.unblock(other) : this.block(other)
    },
    beforeUnload() {
        this.readChat(this.states.activeChat)
    },
    getChats() {
        return new Promise(resolve => {
            this.states.loading_chats = true
            axios.get('/api/v1/chat', {
                params: {token: window.jwt_token},
                headers: {locale: window.locale}
            })
                .then(resp => this.states.chats = _.keyBy(resp.data.data, 'id'))
                .finally(() => {
                    this.states.loading_chats = false;
                    resolve()
                })
        })
    },
    selectChat(chat) {
        this.readChat(this.states.activeChat)
        this.readChat(chat)
        this.leaveChatChannel()

        this.states.messages = []
        this.states.loading_messages = true
        this.states.activeChat = chat
        axios.get('/api/v1/chat/' + chat.id + '/message', {
            params: {token: window.jwt_token, translate: this.states.autoTranslate},
            headers: {locale: window.locale}
        })
            .then(resp => {
                this.states.messages = resp.data.data
                this.states.autoTranslate && this.translateAll()
                this.scrollToLastMessage()
            })
            .finally(() => this.states.loading_messages = false)

        this.joinChatChannel(chat)
    },
    translateAll() {
        let messages = this.states.messages
            .filter(message => message.user.id !== this.states.user.id)

        this.translate(messages)
    },
    originalAll() {
        this.states.translations = []
        this.states.translating = []
    },
    leaveChatChannel() {
        this.states.activeChat !== null && Echo.leave('chat.' + this.states.activeChat.id)
    },
    joinChatChannel(chat) {
        Echo.private('chat.' + chat.id)
            .listenForWhisper('typing', user => {
                console.log(user)
                if (user.is !== this.states.user.id) {
                    clearInterval(this.toggleOtherIsTyping)
                    this.states.otherIsTyping = true
                    this.toggleOtherIsTyping = setTimeout(() => this.states.otherIsTyping = false, 2000)
                }
            })
    },
    broadcastTyping() {
        Echo.private('chat.' + this.states.activeChat.id)
            .whisper('typing', this.states.user)
    },
    sendMessage() {
        let text = this.states.form.text;
        this.states.form.text = '';
        axios({
            method: 'post',
            url: '/api/v1/chat/' + this.states.activeChat.id + '/message',
            data: {text},
            params: {token: window.jwt_token},
            headers: {locale: window.locale}
        })
            .then(resp => {
                // this.states.messages.push(resp.data.data)
                // this.scrollToLastMessage()
            })
            .catch(err => this.showValidationErrors(err))
    },
    showValidationErrors(err) {
        if (err.response && err.response.status === 422) {
            _.forEach(err.response.data.err, errors => {
                Vue.$toast.error(errors[0]);
            })
        } else if (err.response.data.type && err.response.data.type === 'canFeatureValidation') {
            window.subscriptionRequired()
        }
    },
    scrollToLastMessage() {
        this.bus.$emit('scroll-to-last-message')
    },
    joinUserChannel() {
        Echo.private('users.' + this.states.user.id)
            .listen('ChatUpdated', chat => {
                console.log('chat updated', chat)
                // TODO broadcast newly created chats using chatUpdated event
                Vue.set(this.states.chats, chat.id, chat)
            })
            .listen('MessageSent', message => {
                console.log('message sent', message)
                if (message.chat_id === this.states.activeChat.id) {
                    this.states.messages.push(message)
                    this.scrollToLastMessage()
                    this.states.autoTranslate && message.user.id !== this.states.user.id && this.translate(message)
                }
            })
    },
    async leaveUserChannel() {
        await Echo.leave('users.' + this.states.user.id)
    },
    readChat(chat) {
        chat !== null && axios.post('/api/v1/chat/' + chat.id + '/read', {}, {
            params: {token: window.jwt_token},
        }).then(resp => {
            Vue.set(this.states.chats, chat.id, resp.data.data)
        })
    },
    sendAttachment(event) {
        let form = new FormData
        let files = event.target.files;
        for (let i = 0; i < files.length; i++) {
            form.append('attachments[]', files.item(i))
        }
        axios({
            method: 'post',
            url: '/api/v1/chat/' + this.states.activeChat.id + '/message/attachment',
            data: form,
            params: {token: window.jwt_token},
            headers: {'Content-Type': 'multipart/form-data', 'locale': window.locale}
        })
            .then(resp => {
                // this.states.messages.push(resp.data.data)
                // this.scrollToLastMessage()
            })
            .catch(err => this.showValidationErrors(err))
    },
    self_user(chat) {
        return chat.users.filter(user => user.id === this.states.user.id)[0]
    },
    other_user(chat) {
        return chat.users.filter(user => user.id !== this.states.user.id)[0]
    },
    creator(chat) {
        return chat.users.filter(user => user.creator === true)[0]
    },
    has_new_message(chat) {
        return _.get(this.states.activeChat, 'id') !== chat.id && this.self_user(chat).viewed === false
    },
    chat_image(chat) {
        return this.other_user(chat).avatar
    },
    chat_title(chat) {
        return this.other_user(chat).name
    },
}
